var render, staticRenderFns
import script from "./v-data.vue?vue&type=script&lang=js&"
export * from "./v-data.vue?vue&type=script&lang=js&"
import style0 from "./v-data.vue?vue&type=style&index=0&id=8555c34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8555c34a",
  null
  
)

export default component.exports